import { inject, Injectable, Injector } from '@angular/core';
import { WiegungService } from './wiegung-service';
import { Order } from '../types/order';
import { Item } from '../types/material';
import { OrderDetail } from '../types/order-detail';
import { SOFTLINE_SERVICE_HTTP, Store } from '@softline/core';

@Injectable()
export class InventurWiegungService extends WiegungService<OrderDetail['artikel']> {
  readonly type = 'INVENTUR';
  readonly isMaterialRequired = true;
  readonly isOrderRequired = false;

  constructor() {
    super(inject(SOFTLINE_SERVICE_HTTP), inject(Store), inject(Injector));
    console.log('InventurWiegungService');
  }

  weighMaterial(material: OrderDetail['artikel']): void {
  }
}